// extracted by mini-css-extract-plugin
module.exports = {"test":"style_test_1vemm","icon":"style_icon_2Qnj2"};